<template>
    <div>
        <main id="content" class="relative w-full pt-20 xl:pt-28 2.5xl:pt-38">
            <section
                class="relative z-20 flex flex-col items-center w-full h-auto pt-12 pb-16 sm:py-16 lg:py-20 xl:py-12 2xl:py-20"
            >
                <div
                    class="max-w-[calc(100%-3rem)] sm:px-4 md:px-0 sm:max-w-1.5xl xl:max-w-6.5xl 1.5xl:max-w-7xl 2xl:max-w-7xl mx-auto w-full"
                >

                    <h1 class="text-white text-[40px] sm:text-[45px] md:text-[50px] lg:text-[54px] xl:text-[60px] 2xl:text-[64px] 3xl:text-[67px] 3.5xl:text-[70px] !leading-snug font-light tracking-[0.01em] mx-auto text-center mb-14 md:mb-16 lg:mb-18 xl:mb-20 2xl:mb-22 3xl:mb-24">
                        {{ $root.translateString("complete_order") }}
                    </h1>

                    <!-- <p class="text-secondary-400 text-lg xl:text-xl 2.5xl:text-1.5xl !leading-snug max-w-[45ch] text-center mx-auto mb-12 sm:mb-20 px-6" v-html="$root.translateString('gift-message-p')" v-if="should_be_shipped"></p> -->

                    <!-- not logged -->

                    <div
                        class="w-full flex flex-col xl:flex-row space-y-24 sm:space-y-30 xl:space-y-0 xl:space-x-12 2xl:space-x-15 2.5xl:space-x-20"
                    >
                        <!--

                        <div class="relative w-full text-center">

                            <div class="mt-0 checkout-container-row-2__title checkout-title" v-if="!isLogged">
                                <span class="flex items-center justify-center w-10 h-10 p-3 text-xs text-white bg-white/20">01.</span>
                                <span class="text-white text-lg tracking-[0.05em] uppercase text-center">
                                    {{$root.translateString('personal_details')}}
                                </span>
                            </div>
                            <div class="relative w-full" v-if="!isLogged">
                                <div class="cart-dati-1-inputs">

                                    <div class="p-3 mb-3 small-banner d-flex align-items-center">
                                        <a class="cover" href="javascript:void(0)" @click="summonPopup"></a>
                                        <img alt="login" class="mr-1" src="/images/area-utente/user-gold.svg" width="25"/>
                                        <p class="pl-2 mb-0 ml-1 torna-prodotti-link text-lightgrey text-smaller-85 d-inline-flex flex-grow-1">
                                            {{$root.translateString('have-an-account')}}
                                            <span class="ml-2 text-gold" href="javascript:void(0)" @click="toggleLogin">
                                                <span>{{$root.translateString('login-now')}}</span>
                                            </span>
                                        </p>
                                        <span class="mr-1 arrow"><img width="32" src="/images/svg/roeno-17.svg" alt="dettagli"></span>
                                    </div>

                                    <div class="pt-3 double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row">
                                        <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                            <input data-lpignore="true" placeholder=" " type="text" @focus="validation.new_user.name.state = null" v-model="new_user.name">
                                            <div class="invalid-feedback" :class="{'d-block' : validation.new_user.name.state == false}">{{validation.new_user.name.message}}</div>
                                            <label class="full-input__after-input">
                                                {{$root.translateString('name')}}
                                            </label>
                                        </div>
                                        <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                            <div class="full-input__field-gr">
                                                <input data-lpignore="true" placeholder=" " type="text" @focus="validation.new_user.email.state = null" v-model="new_user.email">
                                                <div class="invalid-feedback" :class="{'d-block' : validation.new_user.email.state == false}">{{validation.new_user.email.message}}</div>
                                                <label class="full-input__after-input">
                                                    Email
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="pt-3 mt-4 checkout-container-row-2__checkbox">
                                        <div class="checkbox-styles">
                                            <div class="checkbox">
                                                <input data-lpignore="true" type="checkbox" id="accept_privacy" @change="validation.new_user.privacy.state = null" v-model="new_user.privacy">
                                                <label class="d-inline-block w-100" for="accept_privacy"></label>
                                            </div>
                                            <label for="accept_privacy" class="mb-0 checkbox-styles__link">
                                                {{$root.translateString('acceptance')}} &nbsp;<a :href="'/' + lang + '/privacy-policy'">{{$root.translateString('acceptance_link')}}</a>
                                                <div class="pt-1 invalid-feedback" :class="{'d-block' : validation.new_user.privacy.state == false}">{{validation.new_user.privacy.message}}</div>
                                            </label>
                                        </div>
                                        <div class="mt-3 checkbox-styles">
                                            <div class="checkbox">
                                                <input data-lpignore="true" id="create_account" type="checkbox" v-model="new_user.create_account">
                                                <label class="d-inline-block w-100" for="create_account"></label>
                                            </div>
                                            <label for="create_account" class="mb-0 checkbox-styles__link">
                                                {{$root.translateString('create-new-account')}}
                                            </label>
                                        </div>
                                    </div>


                                    <div class="pt-2 mt-4 double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row" v-if="new_user.create_account">
                                        <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                            <input data-lpignore="true" placeholder=" " type="password" @focus="validation.new_user.password.state = null" v-model="new_user.password">
                                            <div class="invalid-feedback" :class="{'d-block' : validation.new_user.password.state == false}">{{validation.new_user.password.message}}</div>
                                            <label class="full-input__after-input">
                                                {{$root.translateString('password')}}
                                            </label>
                                        </div>
                                        <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                            <div class="full-input__field-gr">
                                                <input data-lpignore="true" placeholder=" " type="password" @focus="validation.new_user.password_confirmation.state = null" v-model="new_user.password_confirmation">
                                                <div class="invalid-feedback" :class="{'d-block' : validation.new_user.password_confirmation.state == false}">{{validation.new_user.password_confirmation.message}}</div>
                                                <label class="full-input__after-input">
                                                    {{$root.translateString('password_confirmation')}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                        -->

                        <div
                            class="relative flex-grow pt-5 space-y-26 xs:space-y-30"
                        >
                            <!-- ///////////////////// SPEDIZIONE -->

                            <div
                                v-if="should_be_shipped"
                                class="relative w-full"
                            >
                                <div
                                    class="relative flex items-center w-full mb-12 space-x-4"
                                >
                                    <span
                                        class="flex items-center justify-center w-10 h-10 p-3 text-base rounded-full bg-white/10 text-primary-300"
                                    >
                                        <span v-if="!isLogged">2</span>
                                        <span v-else>1</span>
                                    </span>
                                    <span
                                        class="text-white text-1.5xl xs:text-2xl tracking-[0.05em] uppercase text-center"
                                    >
                                        {{
                                            $root.translateString(
                                                "shipping_details"
                                            )
                                        }}
                                    </span>
                                </div>

                                <div>
                                    <div
                                        class="relative w-full grid grid-cols-1 xl:grid-cols-2 gap-y-8 sm:gap-y-12 2xl:gap-y-14 2.5xl:gap-y-16 xl:gap-x-12"
                                    >
                                        <!-- <div class="mt-5 mb-5 double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row" v-if="isLogged && (user.addresses.length >= 1 && user.addresses[0].new === false)">
                                            <div class="double-input-select__field-gr w-100 double-input-select__field-gr--less-space-between">
                                                <div class="w-100" >
                                                    <div class="cursor-pointer w-100">
                                                        <div class="select-arrow">
                                                            <img alt="icona" src="/images/svg/roeno-06.svg" width="9"/>
                                                        </div>
                                                        <v-select
                                                            @input="manageSaveAddressCheckbox"
                                                            :clearable="false"
                                                            v-model="address"
                                                            label="label"
                                                            :class="{'full' : (user.addresses != null && user.addresses != '')}"
                                                            :options="user.addresses"
                                                            index="value"
                                                        >
                                                            <template v-slot:no-options="{ search, searching }">
                                                                <template v-if="searching">
                                                                    {{$root.translateString('no_results')}} <strong>{{ search }}</strong>
                                                                </template>
                                                            </template>
                                                            <template slot="selected-option" slot-scope="option">
                                                                <div class="flex">
                                                                    <div class="w-100">
                                                                        {{ option.label }}
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <template slot="option" slot-scope="option">
                                                                {{ option.label }}
                                                            </template>
                                                        </v-select>
                                                        <label class="placeholder">
                                                            {{$root.translateString('select-an-address')}}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->

                                        <!-- <div class="full-input">
                                            <div class="full-input__field-gr">
                                                <input data-lpignore="true" placeholder=" " type="text" @focus="validation.address.name.state = null" v-model="address.name">
                                                <div class="invalid-feedback" :class="{'d-block' : validation.address.name.state == false}">{{validation.address.name.message}}</div>
                                                <label class="full-input__after-input">
                                                    {{$root.translateString('name')}}
                                                </label>
                                            </div>
                                        </div> -->

                                        <span
                                            class="relative block w-full col-span-2"
                                        >
                                            <span
                                                class="relative flex flex-col w-full text-white"
                                            >
                                                <input
                                                    data-lpignore="true"
                                                    @focus="
                                                        validation.address.name.state =
                                                            null
                                                    "
                                                    class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                    placeholder=" "
                                                    type="text"
                                                    v-model="address.name"
                                                />
                                                <label
                                                    class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                                >
                                                    {{
                                                        $root.translateString(
                                                            "name"
                                                        )
                                                    }}
                                                </label>
                                            </span>
                                            <span
                                                v-if="
                                                    validation.address.name
                                                        .state != null
                                                "
                                                class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                            >
                                                {{
                                                    validation.address.name
                                                        .message
                                                }}
                                            </span>
                                        </span>

                                        <span
                                            class="relative block w-full col-span-2 xl:col-span-1"
                                        >
                                            <span
                                                class="relative flex flex-col w-full text-white"
                                            >
                                                <input
                                                    data-lpignore="true"
                                                    @focus="
                                                        validation.address.phone.state =
                                                            null
                                                    "
                                                    class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                    placeholder=" "
                                                    type="tel"
                                                    v-model="address.phone"
                                                />
                                                <label
                                                    class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                                >
                                                    {{
                                                        $root.translateString(
                                                            "phone"
                                                        )
                                                    }}
                                                </label>
                                            </span>
                                            <span
                                                v-if="
                                                    validation.address.phone
                                                        .state != null
                                                "
                                                class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                            >
                                                {{
                                                    validation.address.phone
                                                        .message
                                                }}
                                            </span>
                                        </span>

                                        <span
                                            class="relative block w-full col-span-2 pointer-events-none xl:col-span-1"
                                        >
                                            <span
                                                class="relative flex flex-col w-full text-white"
                                            >
                                                <v-select
                                                    @input="
                                                        validation.address.country.state =
                                                            null
                                                    "
                                                    v-model="address.country"
                                                    :class="{
                                                        full:
                                                            address.country !=
                                                                null &&
                                                            address.country !=
                                                                '',
                                                    }"
                                                    :options="countries"
                                                    label="value"
                                                    index="label"
                                                    :reduce="
                                                        (label) => label.label
                                                    "
                                                    class="pointer-events-none"
                                                >
                                                    <template
                                                        v-slot:no-options="{
                                                            search,
                                                            searching,
                                                        }"
                                                    >
                                                        <template
                                                            v-if="searching"
                                                        >
                                                            <small
                                                                class="not-found"
                                                                >{{
                                                                    $root.translateString(
                                                                        "no_results"
                                                                    )
                                                                }}
                                                                <strong>{{
                                                                    search
                                                                }}</strong></small
                                                            >
                                                        </template>
                                                    </template>
                                                </v-select>

                                                <label
                                                    class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                                >
                                                    {{
                                                        $root.translateString(
                                                            "country"
                                                        )
                                                    }}
                                                </label>
                                            </span>
                                            <span
                                                v-if="
                                                    validation.address.country
                                                        .state != null
                                                "
                                                class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                            >
                                                {{
                                                    validation.address.country
                                                        .message
                                                }}
                                            </span>
                                        </span>

                                        <span
                                            class="relative block w-full col-span-2 xl:col-span-1"
                                        >
                                            <span
                                                class="relative flex flex-col w-full text-white"
                                            >
                                                <input
                                                    data-lpignore="true"
                                                    @focus="
                                                        validation.address.address.state =
                                                            null
                                                    "
                                                    class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                    placeholder=" "
                                                    type="text"
                                                    v-model="address.address"
                                                />
                                                <label
                                                    class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                                >
                                                    {{
                                                        $root.translateString(
                                                            "address"
                                                        )
                                                    }}
                                                </label>
                                            </span>
                                            <span
                                                v-if="
                                                    validation.address.address
                                                        .state != null
                                                "
                                                class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                            >
                                                {{
                                                    validation.address.address
                                                        .message
                                                }}
                                            </span>
                                        </span>

                                        <span
                                            class="relative block w-full col-span-2 xl:col-span-1"
                                        >
                                            <span
                                                class="relative flex flex-col w-full text-white"
                                            >
                                                <input
                                                    data-lpignore="true"
                                                    @focus="
                                                        validation.address.city.state =
                                                            null
                                                    "
                                                    class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                    placeholder=" "
                                                    type="text"
                                                    v-model="address.city"
                                                />
                                                <label
                                                    class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                                >
                                                    {{
                                                        $root.translateString(
                                                            "city"
                                                        )
                                                    }}
                                                </label>
                                            </span>
                                            <span
                                                v-if="
                                                    validation.address.city
                                                        .state != null
                                                "
                                                class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                            >
                                                {{
                                                    validation.address.city
                                                        .message
                                                }}
                                            </span>
                                        </span>

                                        <span
                                            v-if="
                                                address.country.toLowerCase() ==
                                                    'it' ||
                                                address.country.toLowerCase() ==
                                                    ''
                                            "
                                            class="relative block w-full col-span-2 xl:col-span-1"
                                        >
                                            <span
                                                class="relative flex flex-col w-full text-white"
                                            >
                                                <v-select
                                                    @input="
                                                        validation.address.province.state =
                                                            null
                                                    "
                                                    v-model="address.province"
                                                    :options="provinces"
                                                    label="value"
                                                    index="label"
                                                    :reduce="
                                                        (label) => label.label
                                                    "
                                                    @search:focus="
                                                        provinceFocusAddress = true
                                                    "
                                                    @search:blur="
                                                        provinceFocusAddress = false
                                                    "
                                                >
                                                    <template
                                                        v-slot:no-options="{
                                                            search,
                                                            searching,
                                                        }"
                                                    >
                                                        <template
                                                            v-if="searching"
                                                        >
                                                            <small
                                                                class="not-found"
                                                                >{{
                                                                    $root.translateString(
                                                                        "no_results"
                                                                    )
                                                                }}
                                                                <strong>{{
                                                                    search
                                                                }}</strong></small
                                                            >
                                                        </template>
                                                    </template>
                                                </v-select>

                                                <label
                                                    class="whitespace-nowrap text-white text-[20px] sm:text-[22px] md:text-[24px] lg:text-[26px] xl:text-[28px] 2xl:text-[30px] absolute left-1/2 -translate-x-1/2 top-0 !tracking-[0.01em] font-light !leading-4 opacity-50 pointer-events-none transition-all"
                                                    :class="
                                                        ((address.province !=
                                                            null &&
                                                            address.province !=
                                                                '') ||
                                                            provinceFocusAddress) &&
                                                        '!text-xs !-top-4'
                                                    "
                                                >
                                                    {{
                                                        $root.translateString(
                                                            "province"
                                                        )
                                                    }}
                                                </label>
                                            </span>
                                            <span
                                                v-if="
                                                    validation.address.province
                                                        .state != null
                                                "
                                                class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                            >
                                                {{
                                                    validation.address.province
                                                        .message
                                                }}
                                            </span>
                                        </span>

                                        <span
                                            class="relative block w-full col-span-2 xl:col-span-1"
                                        >
                                            <span
                                                class="relative flex flex-col w-full text-white"
                                            >
                                                <input
                                                    data-lpignore="true"
                                                    @focus="
                                                        validation.address.cap.state =
                                                            null
                                                    "
                                                    class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                    placeholder=" "
                                                    type="number"
                                                    v-model="address.cap"
                                                />
                                                <label
                                                    class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                                >
                                                    {{
                                                        $root.translateString(
                                                            "cap"
                                                        )
                                                    }}
                                                </label>
                                            </span>
                                            <span
                                                v-if="
                                                    validation.address.cap
                                                        .state != null
                                                "
                                                class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                            >
                                                {{
                                                    validation.address.cap
                                                        .message
                                                }}
                                            </span>
                                        </span>

                                        <span
                                            class="flex flex-col items-center justify-center w-full col-span-2 space-y-10 sm:flex-row sm:space-y-0"
                                        >
                                            <span class="flex-grow">
                                                <span
                                                    class="flex items-center space-x-3"
                                                >
                                                    <span
                                                        class="w-[30px] h-[30px] relative block"
                                                    >
                                                        <input
                                                            name="marketing"
                                                            id="marketing"
                                                            class="absolute top-0 left-0 w-full h-full outline-none opacity-0 accent-transparent ring-0"
                                                            type="checkbox"
                                                            v-model="marketing"
                                                        />
                                                        <span
                                                            class="absolute top-0 left-0 w-full h-full bg-center bg-no-repeat border pointer-events-none fake-checkbox border-white/50"
                                                        ></span>
                                                    </span>
                                                    <label
                                                        for="marketing"
                                                        class="cursor-pointer"
                                                    >
                                                        <span
                                                            class="text-[18px] md:text-[19px] xl:text-[20px] text-white/50"
                                                        >
                                                            {{
                                                                $root.translateString(
                                                                    "marketing"
                                                                )
                                                            }}
                                                        </span>
                                                    </label>
                                                </span>
                                            </span>
                                        </span>

                                        <!-- <div class="mt-3 checkout-container-row-2__checkbox" v-if="(!hide_save_address || new_user.create_account) && should_be_shipped">
                                            <div class="checkbox-styles">
                                                <div class="checkbox">
                                                    <input data-lpignore="true" type="checkbox" id="save_new_address" v-model="save_new_address">
                                                    <label class="d-inline-block w-100" for="save_new_address"></label>
                                                </div>
                                                <label for="save_new_address" class="mb-0 checkbox-styles__link">
                                                    {{$root.translateString('save-new-address')}}
                                                </label>
                                            </div>
                                        </div> -->

                                        <!-- <span class="flex flex-col items-center justify-center w-full space-y-10 sm:flex-row sm:space-y-0">
                                            <span class="flex-grow">
                                                <span class="flex items-center space-x-3">
                                                    <span class="w-[30px] h-[30px] relative block">
                                                        <input name="require-invoice" id="require-invoice" class="absolute top-0 left-0 w-full h-full outline-none opacity-0 accent-transparent ring-0" type="checkbox" v-model="user.billing.require_invoice">
                                                        <span class="absolute top-0 left-0 w-full h-full bg-center bg-no-repeat border pointer-events-none fake-checkbox border-white/50"></span>
                                                    </span>
                                                    <label for="require-invoice" class="cursor-pointer">
                                                        <span class="text-lg text-white/50 lg:text-xl">{{$root.translateString('ask_for_invoice')}}</span>
                                                    </label>
                                                </span>
                                            </span>
                                        </span> -->
                                    </div>
                                </div>
                            </div>

                            <!-- ////////////////////// FATTURAZIONE -->

                            <div
                                v-if="user.billing.require_invoice"
                                class="relative w-full"
                            >
                                <div
                                    class="relative flex items-center w-full mb-12 space-x-4"
                                >
                                    <span
                                        class="flex items-center justify-center w-10 h-10 p-3 text-base rounded-full bg-white/10 text-primary-300"
                                    >
                                        <span v-if="!isLogged">3</span>
                                        <span v-else>2</span>
                                    </span>
                                    <span
                                        class="text-white text-1.5xl xs:text-2xl tracking-[0.05em] uppercase text-center"
                                    >
                                        {{
                                            $root.translateString(
                                                "invoice_details"
                                            )
                                        }}
                                    </span>
                                </div>

                                <div
                                    class="w-[330px] h-auto relative grid grid-cols-2 mt-12 mb-12 gap-x-4"
                                >
                                    <button
                                        type="button"
                                        @click="billing.type = 'private'"
                                        :class="
                                            billing.type == 'private'
                                                ? 'bg-white/10 py-1.5 rounded-full flex items-center justify-center pointer-events-none px-8'
                                                : 'bg-transparent py-1.5 rounded-full flex items-center justify-center hover:bg-white/10 transition-all px-8'
                                        "
                                    >
                                        <span
                                            class="text-primary-300 text-[18px] md:text-[19px] xl:text-[20px] relative left-0.5"
                                        >
                                            {{
                                                $root.translateString("private")
                                            }}
                                        </span>
                                    </button>
                                    <button
                                        type="button"
                                        @click="billing.type = 'company'"
                                        :class="
                                            billing.type == 'company'
                                                ? 'bg-white/10 py-1.5 rounded-full flex items-center justify-center pointer-events-none px-8'
                                                : 'bg-transparent py-1.5 rounded-full flex items-center justify-center hover:bg-white/10 transition-all px-8'
                                        "
                                    >
                                        <span
                                            class="text-primary-300 text-[18px] md:text-[19px] xl:text-[20px] relative left-0.5"
                                        >
                                            {{
                                                $root.translateString("company")
                                            }}
                                        </span>
                                    </button>
                                </div>

                                <div
                                    class="relative w-full grid grid-cols-2 gap-y-8 sm:gap-y-12 2xl:gap-y-14 2.5xl:gap-y-16 lg:gap-x-12"
                                >
                                    <span
                                        v-if="billing.type == 'company'"
                                        class="relative block w-full col-span-2 xl:col-span-1"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <input
                                                data-lpignore="true"
                                                @focus="
                                                    validation.billing.name.state =
                                                        null
                                                "
                                                class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                placeholder=" "
                                                type="text"
                                                v-model="billing.name"
                                            />
                                            <label
                                                class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                            >
                                                {{
                                                    $root.translateString(
                                                        "company_name"
                                                    )
                                                }}
                                            </label>
                                        </span>
                                        <span
                                            v-if="
                                                validation.billing.name.state !=
                                                null
                                            "
                                            class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                        >
                                            {{
                                                validation.billing.name.message
                                            }}
                                        </span>
                                    </span>

                                    <span
                                        v-if="billing.type == 'company'"
                                        class="relative block w-full col-span-2 xl:col-span-1"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <input
                                                data-lpignore="true"
                                                @focus="
                                                    validation.billing.fiscal_code.state =
                                                        null
                                                "
                                                class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer uppercase"
                                                placeholder=" "
                                                type="text"
                                                v-model="billing.fiscal_code"
                                            />
                                            <label
                                                class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                            >
                                                {{
                                                    $root.translateString("vat")
                                                }}
                                            </label>
                                        </span>
                                        <span
                                            v-if="
                                                validation.billing.fiscal_code
                                                    .state != null
                                            "
                                            class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                        >
                                            {{
                                                validation.billing.fiscal_code
                                                    .message
                                            }}
                                        </span>
                                    </span>

                                    <span
                                        v-if="billing.type == 'company'"
                                        class="relative block w-full col-span-2 xl:col-span-1"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <input
                                                data-lpignore="true"
                                                @focus="
                                                    validation.billing.pec.state =
                                                        null
                                                "
                                                class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                placeholder=" "
                                                type="email"
                                                v-model="billing.pec"
                                            />
                                            <label
                                                class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                            >
                                                {{
                                                    $root.translateString("pec")
                                                }}
                                            </label>
                                        </span>
                                        <span
                                            v-if="
                                                validation.billing.pec.state !=
                                                null
                                            "
                                            class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                        >
                                            {{ validation.billing.pec.message }}
                                        </span>
                                    </span>

                                    <span
                                        v-if="billing.type == 'company'"
                                        class="relative block w-full col-span-2 xl:col-span-1"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <input
                                                data-lpignore="true"
                                                @focus="
                                                    validation.billing.sdi.state =
                                                        null
                                                "
                                                class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                placeholder=" "
                                                type="text"
                                                v-model="billing.sdi"
                                            />
                                            <label
                                                class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                            >
                                                {{
                                                    $root.translateString("sdi")
                                                }}
                                            </label>
                                        </span>
                                        <span
                                            v-if="
                                                validation.billing.sdi.state !=
                                                null
                                            "
                                            class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                        >
                                            {{ validation.billing.sdi.message }}
                                        </span>
                                    </span>

                                    <span
                                        v-if="billing.type == 'company'"
                                        class="relative block w-full col-span-2 xl:col-span-1"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <input
                                                data-lpignore="true"
                                                @focus="
                                                    validation.billing.address.state =
                                                        null
                                                "
                                                class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                placeholder=" "
                                                type="text"
                                                v-model="billing.address"
                                            />
                                            <label
                                                class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                            >
                                                {{
                                                    $root.translateString(
                                                        "address"
                                                    )
                                                }}
                                            </label>
                                        </span>
                                        <span
                                            v-if="
                                                validation.billing.address
                                                    .state != null
                                            "
                                            class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                        >
                                            {{
                                                validation.billing.address
                                                    .message
                                            }}
                                        </span>
                                    </span>

                                    <span
                                        v-if="billing.type == 'company'"
                                        class="relative block w-full col-span-2 xl:col-span-1"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <input
                                                data-lpignore="true"
                                                @focus="
                                                    validation.billing.city.state =
                                                        null
                                                "
                                                class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                placeholder=" "
                                                type="text"
                                                v-model="billing.city"
                                            />
                                            <label
                                                class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                            >
                                                {{
                                                    $root.translateString(
                                                        "city"
                                                    )
                                                }}
                                            </label>
                                        </span>
                                        <span
                                            v-if="
                                                validation.billing.city.state !=
                                                null
                                            "
                                            class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                        >
                                            {{
                                                validation.billing.city.message
                                            }}
                                        </span>
                                    </span>

                                    <span
                                        v-if="billing.type == 'company'"
                                        class="relative block w-full col-span-2 xl:col-span-1"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <v-select
                                                @input="
                                                    validation.billing.province.state =
                                                        null
                                                "
                                                v-model="billing.province"
                                                :options="provinces"
                                                label="value"
                                                index="label"
                                                :reduce="(label) => label.label"
                                                @search:focus="
                                                    provinceFocusBilling = true
                                                "
                                                @search:blur="
                                                    provinceFocusBilling = false
                                                "
                                            >
                                                <template
                                                    v-slot:no-options="{
                                                        search,
                                                        searching,
                                                    }"
                                                >
                                                    <template v-if="searching">
                                                        <small class="not-found"
                                                            >{{
                                                                $root.translateString(
                                                                    "no_results"
                                                                )
                                                            }}
                                                            <strong>{{
                                                                search
                                                            }}</strong></small
                                                        >
                                                    </template>
                                                </template>
                                            </v-select>

                                            <label
                                                class="whitespace-nowrap text-white text-[20px] sm:text-[22px] md:text-[24px] lg:text-[26px] xl:text-[28px] 2xl:text-[30px] absolute left-1/2 -translate-x-1/2 top-0 !tracking-[0.01em] font-light !leading-4 opacity-50 pointer-events-none transition-all"
                                                :class="
                                                    ((billing.province !=
                                                        null &&
                                                        billing.province !=
                                                            '') ||
                                                        provinceFocusBilling) &&
                                                    '!text-xs !-top-4'
                                                "
                                            >
                                                {{
                                                    $root.translateString(
                                                        "province"
                                                    )
                                                }}
                                            </label>
                                        </span>
                                        <span
                                            v-if="
                                                validation.billing.province
                                                    .state != null
                                            "
                                            class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                        >
                                            {{
                                                validation.billing.province
                                                    .message
                                            }}
                                        </span>
                                    </span>

                                    <span
                                        v-if="billing.type == 'company'"
                                        class="relative block w-full col-span-2 xl:col-span-1"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <input
                                                data-lpignore="true"
                                                @focus="
                                                    validation.billing.cap.state =
                                                        null
                                                "
                                                class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                placeholder=" "
                                                type="text"
                                                v-model="billing.cap"
                                            />
                                            <label
                                                class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                            >
                                                {{
                                                    $root.translateString("cap")
                                                }}
                                            </label>
                                        </span>
                                        <span
                                            v-if="
                                                validation.billing.cap.state !=
                                                null
                                            "
                                            class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                        >
                                            {{ validation.billing.cap.message }}
                                        </span>
                                    </span>

                                    <span
                                        v-if="billing.type == 'private'"
                                        class="relative block w-full col-span-2"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <input
                                                data-lpignore="true"
                                                @focus="
                                                    validation.billing.fiscal_code.state =
                                                        null
                                                "
                                                class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                placeholder=" "
                                                type="text"
                                                v-model="billing.fiscal_code"
                                            />
                                            <label
                                                class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                            >
                                                {{
                                                    $root.translateString(
                                                        "fiscal_code"
                                                    )
                                                }}
                                            </label>
                                        </span>
                                        <span
                                            v-if="
                                                validation.billing.fiscal_code
                                                    .state != null
                                            "
                                            class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                        >
                                            {{
                                                validation.billing.fiscal_code
                                                    .message
                                            }}
                                        </span>
                                    </span>

                                    <!-- <div class="mt-2 checkout-container-row-2__checkbox mt-lg-5" v-if="!hide_save_billing_info || new_user.create_account">
                                        <div class="checkbox-styles">
                                            <div class="checkbox">
                                                <input data-lpignore="true" type="checkbox" id="save_billing_info" class="cb" name="save_billing_info" v-model="save_billing_info">
                                                <label for="save_billing_info"></label>
                                            </div>
                                            <label for="save_billing_info" class="mb-0 checkbox-styles__link checkout">
                                                <span>{{$root.translateString('update-billing-data')}}</span>
                                            </label>
                                        </div>
                                    </div> -->
                                </div>
                            </div>

                            <!-- ////////////////////// PAGAMENTO -->

                            <div class="relative w-full">
                                <div
                                    class="relative flex items-center w-full mb-6 space-x-4 md:mb-12"
                                >
                                    <span
                                        class="flex items-center justify-center w-10 h-10 p-3 text-base rounded-full bg-white/10 text-primary-300"
                                    >
                                        <template
                                            v-if="address.country == 'IT'"
                                        >
                                            <span v-if="!isLogged">4</span>
                                            <span v-else>3</span>
                                        </template>
                                        <template v-else>
                                            <span>2</span>
                                        </template>
                                    </span>
                                    <span
                                        class="text-white text-1.5xl xs:text-2xl tracking-[0.05em] uppercase text-center"
                                    >
                                        <span class="xs:hidden">{{
                                            $root.translateString(
                                                "payment_methods_short"
                                            )
                                        }}</span>
                                        <span class="hidden xs:inline">{{
                                            $root.translateString(
                                                "payment_methods"
                                            )
                                        }}</span>
                                    </span>
                                </div>

                                <div class="relative flex flex-col w-full">
                                    <button
                                        type="button"
                                        @click="pay.method = 'stripe'"
                                        class="flex flex-col py-6 space-x-3 border-b cursor-pointer xs:flex-row xs:items-center border-white/50"
                                    >
                                        <span
                                            class="flex items-center flex-grow space-x-2 xs:space-x-3"
                                        >
                                            <span
                                                class="flex justify-center items-center min-w-[20px] min-h-[20px] rounded-full border border-primary-400"
                                            >
                                                <span
                                                    v-if="
                                                        pay.method == 'stripe'
                                                    "
                                                    class="block w-2 h-2 rounded-full bg-primary-400"
                                                ></span>
                                            </span>
                                            <span
                                                class="flex flex-col items-start flex-grow pl-2"
                                            >
                                                <span
                                                    class="text-white text-lg xs:text-xl tracking-[0.05em] uppercase"
                                                >
                                                    {{
                                                        $root.translateString(
                                                            "credit_card"
                                                        )
                                                    }}
                                                </span>
                                                <span
                                                    class="flex !leading-none text-left items-center text-secondary-400 pt-1 xs:pt-0 text-lg"
                                                    v-if="
                                                        pay.method == 'stripe'
                                                    "
                                                >
                                                    {{
                                                        $root.translateString(
                                                            "credit_card_p"
                                                        )
                                                    }}
                                                </span>
                                            </span>
                                        </span>
                                        <span
                                            class="flex items-center h-full pt-3 pl-6 xs:pt-0 xs:pl-0"
                                        >
                                            <img
                                                class="w-auto h-7"
                                                src="/images/svg/credit-card.svg"
                                                alt="Carta di credito"
                                                height="25"
                                            />
                                        </span>
                                    </button>

                                    <button
                                        type="button"
                                        @click="pay.method = 'bank'"
                                        class="flex flex-col py-6 space-x-3 border-b cursor-pointer xs:flex-row xs:items-center border-white/50"
                                    >
                                        <span
                                            class="flex items-center flex-grow space-x-2 xs:space-x-3"
                                        >
                                            <span
                                                class="flex justify-center items-center min-w-[20px] min-h-[20px] rounded-full border border-primary-400"
                                            >
                                                <span
                                                    v-if="pay.method == 'bank'"
                                                    class="block w-2 h-2 rounded-full bg-primary-400"
                                                ></span>
                                            </span>
                                            <span
                                                class="flex flex-col items-start flex-grow pl-2"
                                            >
                                                <span
                                                    class="text-white text-lg xs:text-xl tracking-[0.05em] uppercase"
                                                >
                                                    {{
                                                        $root.translateString(
                                                            "wire_transfer"
                                                        )
                                                    }}
                                                </span>
                                                <span
                                                    class="flex !leading-none text-left items-center text-secondary-400 pt-1 xs:pt-0 text-lg"
                                                    v-if="pay.method == 'bank'"
                                                >
                                                    {{
                                                        $root.translateString(
                                                            "wire_transfer_p"
                                                        )
                                                    }}
                                                </span>
                                            </span>
                                        </span>
                                        <span
                                            class="flex items-center h-full pt-3 pl-6 xs:pt-0 xs:pl-0"
                                        >
                                            <img
                                                class="w-auto h-7"
                                                src="/images/svg/bankwire.svg"
                                                alt="Bonifico bancario"
                                                height="25"
                                            />
                                        </span>
                                    </button>

                                    <button
                                        type="button"
                                        @click="pay.method = 'paypal'"
                                        class="flex flex-col py-6 space-x-3 border-b cursor-pointer xs:flex-row xs:items-center border-white/50"
                                    >
                                        <span
                                            class="flex items-center flex-grow space-x-2 xs:space-x-3"
                                        >
                                            <span
                                                class="flex justify-center items-center min-w-[20px] min-h-[20px] rounded-full border border-primary-400"
                                            >
                                                <span
                                                    v-if="
                                                        pay.method == 'paypal'
                                                    "
                                                    class="block w-2 h-2 rounded-full bg-primary-400"
                                                ></span>
                                            </span>
                                            <span
                                                class="flex flex-col items-start flex-grow pl-2"
                                            >
                                                <span
                                                    class="text-white text-lg xs:text-xl tracking-[0.05em] uppercase"
                                                >
                                                    Paypal
                                                </span>
                                                <span
                                                    class="flex !leading-none text-left items-center text-secondary-400 pt-1 xs:pt-0 text-lg"
                                                    v-if="
                                                        pay.method == 'paypal'
                                                    "
                                                >
                                                    {{
                                                        $root.translateString(
                                                            "paypal_p"
                                                        )
                                                    }}
                                                </span>
                                            </span>
                                        </span>
                                        <span
                                            class="flex items-center h-full pt-3 pl-6 xs:pt-0 xs:pl-0"
                                        >
                                            <img
                                                class="w-auto h-7"
                                                src="/images/svg/paypal.svg"
                                                alt="Paypal"
                                                height="25"
                                            />
                                        </span>
                                    </button>

                                    <button
                                        type="button"
                                        @click="pay.method = 'applePay'"
                                        class="flex flex-col py-6 space-x-3 border-b cursor-pointer xs:flex-row xs:items-center border-white/50"
                                        v-if="paymentRequest != null"
                                    >
                                        <span
                                            class="flex items-center flex-grow space-x-2 xs:space-x-3"
                                        >
                                            <span
                                                class="flex justify-center items-center min-w-[20px] min-h-[20px] rounded-full border border-primary-400"
                                            >
                                                <span
                                                    v-if="
                                                        pay.method == 'applePay'
                                                    "
                                                    class="block w-2 h-2 rounded-full bg-primary-400"
                                                ></span>
                                            </span>
                                            <span
                                                class="flex flex-col items-start flex-grow pl-2"
                                            >
                                                <span
                                                    class="text-white text-lg xs:text-xl tracking-[0.05em] uppercase"
                                                >
                                                    Apple Pay / Google Pay
                                                </span>
                                                <span
                                                    class="flex !leading-none text-left items-center text-secondary-400 pt-1 xs:pt-0 text-lg"
                                                    v-if="
                                                        pay.method == 'applePay'
                                                    "
                                                >
                                                    {{
                                                        $root.translateString(
                                                            "apple_pay_p"
                                                        )
                                                    }}
                                                </span>
                                            </span>
                                        </span>
                                        <span
                                            class="flex items-center h-full pt-3 pl-6 xs:pt-0 xs:pl-0"
                                        >
                                            <img
                                                class="w-auto h-7"
                                                src="/images/svg/apple-google-pay.svg"
                                                alt="Apple Pay - Google Pay"
                                                height="25"
                                            />
                                        </span>
                                    </button>
                                </div>
                            </div>

                            <!-- ////////////////////// MESSAGGIO -->

                            <div class="relative w-full">
                                <div
                                    class="relative flex items-center w-full mb-12 space-x-4"
                                >
                                    <span
                                        class="flex items-center justify-center w-10 h-10 p-3 text-base rounded-full bg-white/10 text-primary-300"
                                    >
                                        <template
                                            v-if="address.country == 'IT'"
                                        >
                                            <span v-if="!isLogged">5</span>
                                            <span v-else>4</span>
                                        </template>
                                        <template v-else>
                                            <span>3</span>
                                        </template>
                                    </span>
                                    <span
                                        class="text-white text-1.5xl xs:text-2xl tracking-[0.05em] uppercase text-center"
                                    >
                                        {{
                                            $root.translateString(
                                                "ask_for_gift"
                                            )
                                        }}
                                    </span>
                                </div>

                                <div class="relative flex flex-col w-full">
                                    <span
                                        v-if="giftPack.status"
                                        class="relative block w-full"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <textarea
                                                rows="3"
                                                class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[141px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                placeholder=" "
                                                v-model="giftPack.message"
                                            ></textarea>
                                            <label
                                                class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                            >
                                                {{
                                                    $root.translateString(
                                                        "giftpack_title"
                                                    )
                                                }}
                                            </label>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- -->

                        <div
                            class="flex flex-col w-full space-y-8 xl:w-[460px] xl:sticky xl:top-[110px] 2.5xl:top-[130px] self-start"
                        >
                            <div
                                class="p-6 sm:p-10 xl:p-12 xl:w-auto w-full text-lg sm:text-xl xl:text-xl 2.5xl:text-1.5xl text-secondary-400 bg-white/5"
                            >
                                <!-- <h4 class="text-white text-lg tracking-[0.05em] uppercase text-center mb-6 xl:-mt-2">
                                    {{$root.translateString('summary')}}
                                </h4> -->

                                <div
                                    class="relative flex flex-col w-full pb-6 mb-6 space-y-6 border-b border-secondary-400/20"
                                >
                                    <div
                                        class="flex items-start w-full"
                                        v-for="(item, key) in cart"
                                        :key="key"
                                    >
                                        <div
                                            class="flex items-center justify-center w-16 h-16 p-3 min-w-16 xs:w-20 xs:min-w-20 xs:h-20 md:w-22 md:min-w-22 md:h-22 bg-white/10"
                                        >
                                            <img
                                                width="70"
                                                class="object-contain w-full h-full"
                                                :src="item.options.image"
                                                :alt="item.options.name"
                                            />
                                        </div>
                                        <div
                                            class="flex flex-col flex-grow pl-6"
                                        >
                                            <div
                                                class="flex flex-grow w-full pt-0 pl-0"
                                            >
                                                <span
                                                    class="pr-2 h-full whitespace-nowrap relative -top-1.5"
                                                    >{{ item.qty }} x</span
                                                >
                                                <span
                                                    class="flex flex-col flex-grow"
                                                >
                                                    <span
                                                        class="uppercase text-white !leading-tight text-lg"
                                                        v-text="
                                                            item.options.name
                                                        "
                                                    ></span>
                                                    <span
                                                        class="w-full flex flex-col text-lg !leading-snug -mt-0.5"
                                                    >
                                                        <span
                                                            class="w-full"
                                                            v-if="
                                                                item.options
                                                                    .type ==
                                                                'vini'
                                                            "
                                                            v-text="
                                                                item.options
                                                                    .combination
                                                            "
                                                        ></span>
                                                        <span
                                                            class="w-full"
                                                            v-else-if="
                                                                item.options
                                                                    .type ==
                                                                'visite'
                                                            "
                                                        >
                                                            {{
                                                                parseInt(
                                                                    item.options
                                                                        .visit
                                                                        .adults
                                                                ) +
                                                                parseInt(
                                                                    item.options
                                                                        .visit
                                                                        .kids
                                                                )
                                                            }}
                                                            <span
                                                                v-if="
                                                                    item.options
                                                                        .visit
                                                                        .adults ==
                                                                    1
                                                                "
                                                                >{{
                                                                    $root.translateString(
                                                                        "person"
                                                                    )
                                                                }}</span
                                                            >
                                                            <span v-else>{{
                                                                $root.translateString(
                                                                    "people"
                                                                )
                                                            }}</span>
                                                            <span
                                                                v-if="
                                                                    item.options
                                                                        .combination
                                                                "
                                                            >
                                                                -
                                                                {{
                                                                    item.options.combination.replace(
                                                                        " ",
                                                                        ""
                                                                    )
                                                                }}
                                                            </span>
                                                        </span>
                                                        <span
                                                            class="w-full"
                                                            v-else
                                                            >Cantina
                                                            Letrari</span
                                                        >
                                                    </span>
                                                </span>
                                            </div>
                                            <div
                                                class="flex items-center flex-grow py-0 pl-0 mt-2"
                                            >
                                                <span
                                                    class="flex-grow text-base"
                                                >
                                                    €
                                                    {{
                                                        $root.currencyDisplaySimple(
                                                            parseFloat(
                                                                item.price
                                                            ) *
                                                                parseInt(
                                                                    item.qty
                                                                )
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="flex items-center justify-center w-full px-3 py-2 mb-4 text-center bg-primary-400/20 sm:px-6 sm:py-3"
                                >
                                    <span
                                        class="text-[15px] uppercase text-white !tracking-[0.05em]"
                                        >{{
                                            $root.translateString(
                                                "free_shipping"
                                            )
                                        }}
                                        <span>€110</span></span
                                    >
                                </div>

                                <div
                                    class="pb-5 mb-3 text-center border-b text-primary-400 border-secondary-400/20"
                                    v-if="missing_for_free_shipping > 0"
                                >
                                    <span
                                        class="!leading-none block w-full text-center"
                                        v-if="lang == 'it'"
                                    >
                                        Sei a €
                                        {{
                                            $root.currencyDisplaySimple(
                                                missing_for_free_shipping
                                            )
                                        }}
                                        dalla spedizione gratuita.
                                    </span>
                                    <span
                                        class="!leading-none block w-full text-center"
                                        v-else
                                    >
                                        €
                                        {{
                                            $root.currencyDisplaySimple(
                                                missing_for_free_shipping
                                            )
                                        }}
                                        left for free shipping.
                                    </span>
                                </div>

                                <div class="flex pb-2">
                                    <div class="flex-grow">
                                        {{ $root.translateString("subtotal") }}
                                    </div>
                                    <div class="">
                                        €
                                        {{
                                            $root.currencyDisplaySimple(
                                                priceTotalWt
                                            )
                                        }}
                                    </div>
                                </div>

                                <div
                                    class="flex pb-4 spedizione"
                                    v-if="should_be_shipped"
                                >
                                    <div class="flex-grow">
                                        {{ $root.translateString("shipping") }}
                                    </div>
                                    <div class="">
                                        <span v-if="shipping > 0">
                                            €
                                            {{
                                                $root.currencyDisplaySimple(
                                                    shipping
                                                )
                                            }}
                                        </span>
                                        <span v-else>{{
                                            $root.translateString("free")
                                        }}</span>
                                    </div>
                                </div>

                                <div
                                    class="flex pb-4 spedizione"
                                    v-if="discount > 0"
                                >
                                    <div class="flex-grow">
                                        {{ $root.translateString("discount") }}
                                    </div>
                                    <div class="">
                                        €
                                        {{
                                            $root.currencyDisplaySimple(
                                                discount
                                            )
                                        }}
                                    </div>
                                </div>

                                <div
                                    class="flex py-3 border-t border-secondary-400/20"
                                >
                                    <div class="flex flex-col flex-grow">
                                        <div class="text-white">
                                            {{ $root.translateString("total") }}
                                        </div>
                                        <small class="-mt-2">{{
                                            $root.translateString(
                                                "tax_included"
                                            )
                                        }}</small>
                                    </div>
                                    <div class="text-white">
                                        €
                                        {{
                                            $root.currencyDisplaySimple(
                                                finalPrice
                                            )
                                        }}
                                    </div>
                                </div>

                                <div class="w-full pt-2 mt-1 text-center">
                                    <div class="flex w-full">
                                        <button
                                            type="button"
                                            v-if="pay.method != 'applePay'"
                                            @click="createOrder"
                                            :class="{ loading: loading }"
                                            :disabled="btn_disabled"
                                            class="relative inline-flex border default-btn border-primary-300 group flex-grow w-full text-center xl:max-w-[340px] 2xl:max-w-[386px] hover:bg-primary-400/10 transition-all"
                                        >
                                            <span class="block w-full pt-2.5 pb-3 px-15 text-primary-300 text-[18px] md:text-[19px] xl:text-[20px]">
                                                {{$root.translateString('complete_order')}}
                                            </span>
                                            <span class="absolute top-1/2 -translate-y-1/2 -left-[8px] w-[16px] h-[1px] bg-primary-300 group-hover:left-6 transition-all"></span>
                                            <span class="absolute top-1/2 -translate-y-1/2 -right-[8px] w-[16px] h-[1px] bg-primary-300 group-hover:right-6 transition-all"></span>
                                        </button>
                                        <button
                                            type="button"
                                            v-else
                                            @click="
                                                paymentRequest.show(),
                                                    createOrder()
                                            "
                                            href="javascript:void(0)"
                                            :class="{ loading: loading }"
                                            :disabled="btn_disabled"
                                            class="relative inline-flex border default-btn border-primary-300 group flex-grow w-full text-center xl:max-w-[340px] 2xl:max-w-[386px] hover:bg-primary-400/10 transition-all"
                                        >
                                            <span class="block w-full pt-2.5 pb-3 px-15 text-primary-300 text-[18px] md:text-[19px] xl:text-[20px]">
                                                {{$root.translateString('complete_order')}}
                                            </span>
                                            <span class="absolute top-1/2 -translate-y-1/2 -left-[8px] w-[16px] h-[1px] bg-primary-300 group-hover:left-6 transition-all"></span>
                                            <span class="absolute top-1/2 -translate-y-1/2 -right-[8px] w-[16px] h-[1px] bg-primary-300 group-hover:right-6 transition-all"></span>
                                        </button>
                                    </div>
                                </div>

                                <!-- ////////////////////// TERMINI-->

                                <div
                                    class="relative w-full px-5 pt-4 border-t border-secondary-400/20 mt-7 2xl:-mb-2"
                                >
                                    <span
                                        class="text-secondary-400 text-xs space-x-2 space-y-1.5 !leading-normal block text-center"
                                        v-html="
                                            $root.translateString('before-buy')
                                        "
                                    ></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
import moment from "moment";

export default {
    props: ["lang", "provinces", "countries", "isLogged", "userProp"],
    data() {
        return {
            user: {
                addresses: [],
                billing: {
                    require_invoice: true,
                    data: {
                        type: "private",
                        name: "",
                        fiscal_code: "",
                        sdi: "",
                        pec: "",
                        address: "",
                        city: "",
                        cap: "",
                        province: "",
                        country: "IT",
                    },
                },
            },
            provinceFocusAddress: false,
            provinceFocusBilling: false,
            hide_save_billing_info: true,
            save_billing_info: false,
            save_new_address: false,
            hide_save_address: true,
            marketing: false,
            new_user: {
                name: "",
                email: "",
                password: "",
                confirm_password: "",
                create_account: false,
            },
            hasGift: false,
            stripeObject: null,
            paymentRequest: null,
            loading: false,
            pay: {
                method: "stripe",
            },
            discount_placeholder: true,
            giftPack: {
                status: true,
                message: "",
            },
            address: {
                name: "",
                address: "",
                city: "",
                cap: "",
                province: "",
                country: "IT",
            },
            billing: {
                type: "company", //normally is private, here we forced company
                name: "",
                fiscal_code: "",
                sdi: "",
                pec: "",
                address: "",
                city: "",
                cap: "",
                province: "",
                country: "IT",
            },
            discountCode: "",
            cartRaw: null,
            priceTotalWt: 0,
            finalPrice: 0,
            shipping: 0,
            discount: 0,
            count: 0,
            showDiscountBox: false,
            missing_for_free_shipping: 0,
            validation: {
                new_user: {
                    name: {
                        state: null,
                        message: "",
                    },
                    email: {
                        state: null,
                        message: "",
                    },
                    phone: {
                        state: null,
                        message: "",
                    },
                    password: {
                        state: null,
                        message: "",
                    },
                    password_confirmation: {
                        state: null,
                        message: "",
                    },
                    privacy: {
                        state: null,
                        message: "",
                    },
                },
                address: {
                    name: {
                        state: null,
                        message: "",
                    },
                    phone: {
                        state: null,
                        message: "",
                    },
                    address: {
                        state: null,
                        message: "",
                    },
                    /*email: {
                            state: null,
                            message: '',
                        },*/
                    city: {
                        state: null,
                        message: "",
                    },
                    cap: {
                        state: null,
                        message: "",
                    },
                    province: {
                        state: null,
                        message: "",
                    },
                    country: {
                        state: null,
                        message: "",
                    },
                    /*privacy: {
                            state: null,
                            message: '',
                        },*/
                },
                billing: {
                    name: {
                        state: null,
                        message: "",
                    },
                    fiscal_code: {
                        state: null,
                        message: "",
                    },
                    sdi: {
                        state: null,
                        message: "",
                    },
                    pec: {
                        state: null,
                        message: "",
                    },
                    address: {
                        state: null,
                        message: "",
                    },
                    city: {
                        state: null,
                        message: "",
                    },
                    cap: {
                        state: null,
                        message: "",
                    },
                    province: {
                        state: null,
                        message: "",
                    },
                    country: {
                        state: null,
                        message: "",
                    },
                },
                discount: {
                    state: null,
                    message: "",
                },
            },
            btn_disabled: false,
            profile_loaded: false,
            billing_memo: null,
            should_be_shipped: false,
        };
    },
    created() {
        if (typeof this.userProp != "undefined" && this.isLogged) {
            if (
                typeof this.userProp.billing !== "undefined" &&
                this.userProp.billing != null
            ) {
                this.$set(this.user, "billing", this.userProp.billing);
            }

            this.$set(this.user, "addresses", this.userProp.addresses);

            let new_address = {
                new: true,
                label: "Usa nuovo indirizzo",
                name: "",
                address: "",
                city: "",
                cap: "",
                province: "",
                country: "IT",
            };

            for (let i = 0; i < this.user.addresses.length; i++) {
                this.$set(this.user.addresses[i], "new", false);
                this.$set(
                    this.user.addresses[i],
                    "label",
                    this.user.addresses[i].address +
                        " - " +
                        this.user.addresses[i].cap +
                        " - " +
                        this.user.addresses[i].city +
                        " (" +
                        this.user.addresses[i].province +
                        ")"
                );
            }

            if (this.user.addresses.length == 0) {
                this.hide_save_address = false;
            }

            this.user.addresses.push(new_address);

            this.address = this.user.addresses[0];
            this.billing = this.user.billing.data;

            this.billing_memo = JSON.parse(JSON.stringify(this.billing));
        }

        if (this.isLogged && this.userProp.billing == null) {
            this.hide_save_billing_info = false;
        }

        this.getCart();
    },
    watch: {
        billing: {
            handler: function (n, o) {
                if (
                    this.profile_loaded &&
                    this.isLogged &&
                    this.userProp.billing != null
                ) {
                    if (
                        JSON.stringify(n) != JSON.stringify(this.billing_memo)
                    ) {
                        this.hide_save_billing_info = false;
                    } else {
                        this.hide_save_billing_info = true;
                    }
                }
            },
            deep: true,
        },
        "user.billing.require_invoice": {
            handler: function (n, o) {
                if (!n && this.isLogged) {
                    this.billing = this.billing_memo;
                }
            },
            deep: true,
        },
        "address.country": {
            handler: function (n, o) {
                if (n != "IT") {
                    this.pay.method = "bank";
                    this.address.province = "";
                    this.user.billing.require_invoice = false;
                } else {
                    this.pay.stripe = "stripe";
                }
            },
        },
    },
    mounted() {
        this.$eventHub.$on("discount.applied", (payload) => {
            this.getCart();
        });
    },
    methods: {
        summonPopup() {
            this.$eventHub.$emit("login", { hide_register: true });
        },
        manageSaveAddressCheckbox() {
            if (this.address.new) {
                this.hide_save_address = false;
            } else {
                this.hide_save_address = true;
                this.save_new_address = false;
            }
        },
        toggleLogin() {
            this.$eventHub.$emit("login", {});
        },
        loadStripe() {
            axios.get("/api/cart/stripe").then((response) => {
                this.stripeObject = Stripe(response.data.pkey);

                // var paymentRequest = this.stripeObject.paymentRequest({
                //     country: "IT",
                //     currency: "eur",
                //     total: {
                //         label: "Ordine Shop Cantina Letrari",
                //         amount: parseInt(parseFloat(this.finalPrice) * 100),
                //     },
                //     requestPayerName: true,
                //     requestPayerEmail: true,
                // });

                // // Check the availability of the Payment Request API first.
                // paymentRequest.canMakePayment().then((result) => {
                //     if (result) {
                //         this.paymentRequest = paymentRequest;
                //     } else {
                //         this.paymentRequest = null;
                //     }
                // });

                this.paymentRequest = null;
            });
        },
        getCart() {
            axios.get("/api/cart/get").then((response) => {
                this.cartRaw = response.data.cart;
                this.count = response.data.count;
                this.priceTotalWt = response.data.priceTotalWt;
                this.finalPrice = response.data.finalPrice;
                this.shipping = response.data.shipping;
                this.discount = response.data.discount;
                this.missing_for_free_shipping =
                    response.data.missingForFreeShipping;
                this.should_be_shipped = response.data.shouldBeShipped;
                this.hasGift = response.data.hasGift;
                this.loadStripe();

                if (!this.should_be_shipped) {
                    this.hide_save_address = true;
                }

                if (this.cart.length == 0) {
                    window.location.href = "/carrello";
                } else {
                    let products_gtm = [];

                    Object.keys(this.cart).forEach((key) => {
                        let entry = {};
                        entry.item_id = this.cart[key].id;
                        entry.quantity = this.cart[key].qty;
                        entry.item_brand = "Cantina Letrari";
                        entry.item_name = this.cart[key].options.name.replace(
                            "<br>",
                            " "
                        );
                        entry.price = String(this.cart[key].price).replace(
                            ",",
                            "."
                        );
                        entry.item_variant =
                            this.cart[key].options.combination.toLowerCase();
                        entry.item_category = this.cart[key].options.type;
                        products_gtm.push(entry);
                    });

                    dataLayer.push({ ecommerce: null });
                    dataLayer.push({
                        event: "begin_checkout",
                        ecommerce: {
                            items: products_gtm,
                        },
                    });

                    //

                    let temp_cart = [];
                    let temp_cart_ids = [];

                    Object.keys(this.cart).forEach((key) => {
                        let entry = {};
                        entry.id = this.cart[key].name.replace("<br>", " ");
                        entry.quantity = this.cart[key].qty;
                        temp_cart.push(entry);
                        temp_cart_ids.push(entry.id);
                    });

                    fbq("track", "InitiateCheckout", {
                        content_category: "checkout",
                        content_ids: temp_cart_ids,
                        contents: temp_cart,
                        currency: "EUR",
                        num_items: this.cart.length,
                        value: this.finalPrice,
                    });

                    this.profile_loaded = true;
                }
            });
        },
        createOrder() {
            this.btn_disabled = true;
            if (this.canProceed()) {
                this.loading = true;

                if (this.giftPack.message == "") {
                    this.giftPack.status = false;
                }

                axios
                    .post("/api/cart/create-order", {
                        lang: this.lang,
                        pay: this.pay.method,
                        address: this.address,
                        save_new_address: this.save_new_address,
                        save_billing_info: this.save_billing_info,
                        new_user: this.new_user,
                        require_invoice: this.user.billing.require_invoice,
                        billing: this.billing,
                        discountCode: this.discountCode,
                        giftPack: this.giftPack,
                        marketing: this.marketing,
                    })
                    .then((response) => {
                        if (response.data.action == "stripe_js") {
                            //var stripe = Stripe(response.data.pkey);
                            this.stripeObject
                                .redirectToCheckout({
                                    sessionId: response.data.payment_intent,
                                })
                                .then(function (result) {
                                    result.error.message;
                                    this.btn_disabled = false;
                                });
                        } else if (response.data.action == "stripe_apple_pay") {
                            var stripe = this.stripeObject;
                            var clientSecret = response.data.client_secret;
                            var confirm_page = response.data.confirm_page;

                            this.paymentRequest.on(
                                "paymentmethod",
                                async (ev) => {
                                    // Confirm the PaymentIntent without handling potential next actions (yet).
                                    const {
                                        paymentIntent,
                                        error: confirmError,
                                    } = await stripe.confirmCardPayment(
                                        clientSecret,
                                        { payment_method: ev.paymentMethod.id },
                                        { handleActions: false }
                                    );

                                    if (confirmError) {
                                        console.log(error);
                                        console.log(confirmError);
                                        // Report to the browser that the payment failed, prompting it to
                                        // re-show the payment interface, or show an error message and close
                                        // the payment interface.
                                        ev.complete("fail");
                                    } else {
                                        console.log(paymentIntent);
                                        // Report to the browser that the confirmation was successful, prompting
                                        // it to close the browser payment method collection interface.
                                        ev.complete("success");
                                        // Check if the PaymentIntent requires any actions and, if so, let Stripe.js
                                        // handle the flow. If using an API version older than "2019-02-11"
                                        // instead check for: `paymentIntent.status === "requires_source_action"`.
                                        if (
                                            paymentIntent.status ===
                                            "requires_action"
                                        ) {
                                            // Let Stripe.js handle the rest of the payment flow.
                                            const { error } =
                                                await stripe.confirmCardPayment(
                                                    clientSecret
                                                );
                                            if (error) {
                                                // The payment failed -- ask your customer for a new payment method.
                                            } else {
                                                // The payment has succeeded -- show a success message to your customer.
                                                window.location.href =
                                                    confirm_page;
                                            }
                                        } else {
                                            // The payment has succeeded -- show a success message to your customer.
                                            window.location.href = confirm_page;
                                        }
                                    }
                                }
                            );
                        } else if (response.data.action == "redirect") {
                            window.location.href = response.data.next_action;
                        }
                    })
                    .catch((e) => {
                        if (typeof e.response.data.location != "undefined") {
                            window.location.href = e.response.data.location;
                        } else {
                            window.location.reload(true);
                        }
                    });
            }
        },
        isNotEmpty(object) {
            return _.isEmpty(object) === false;
        },
        canProceed() {
            let is_invalid = false;

            /* */

            if (!this.isLogged) {
                Object.keys(this.validation.new_user).forEach((elem, key) => {
                    this.validation.new_user[elem].message = "";
                    this.validation.new_user[elem].state = null;
                });

                if (this.new_user.name == "") {
                    if (this.lang == "it") {
                        this.validation.new_user.name.message =
                            "Questo campo non può essere vuoto.";
                    } else {
                        this.validation.new_user.name.message =
                            "This field cannot be empty.";
                    }
                    this.validation.new_user.name.state = false;
                    is_invalid = true;
                } else {
                    this.validation.new_user.name.state = null;
                }

                let re =
                    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                let disposable = require("is-disposable-email");
                if (!re.test(this.new_user.email)) {
                    if (this.lang == "it") {
                        this.validation.new_user.email.message =
                            "Non sembra un indirizzo email valido.";
                    } else {
                        this.validation.new_user.email.message =
                            "The email address is invalid.";
                    }
                    this.validation.new_user.email.state = false;
                    is_invalid = true;
                } else {
                    if (disposable(this.new_user.email)) {
                        if (this.lang == "it") {
                            this.validation.new_user.email.message =
                                "Tipologia di servizio email non valido.";
                        } else {
                            this.validation.new_user.email.message =
                                "You email provider is invalid.";
                        }
                        this.validation.new_user.email.state = false;
                        is_invalid = true;
                    } else {
                        this.validation.new_user.email.state = null;
                    }
                }

                if (this.new_user.create_account) {
                    if (this.new_user.password == "") {
                        if (this.lang == "it") {
                            this.validation.new_user.password.message =
                                "Questo campo non può essere vuoto.";
                        } else {
                            this.validation.new_user.password.message =
                                "This field cannot be empty.";
                        }
                        this.validation.new_user.password.state = false;
                        is_invalid = true;
                    } else {
                        this.validation.new_user.password.state = null;
                    }

                    if (
                        this.new_user.password_confirmation !=
                            this.new_user.password ||
                        this.user.password_confirmation == ""
                    ) {
                        if (this.lang == "it") {
                            this.validation.new_user.password_confirmation.message =
                                "Questo campo deve coincidere con la password.";
                        } else {
                            this.validation.new_user.password_confirmation.message =
                                "Questo campo non può essere vuoto.";
                        }
                        this.validation.new_user.password_confirmation.state = false;
                        is_invalid = true;
                    } else {
                        this.validation.new_user.password_confirmation.state =
                            null;
                    }
                }

                if (!this.new_user.privacy) {
                    if (this.lang == "it") {
                        this.validation.new_user.privacy.message =
                            "È necessario accettare i termini.";
                    } else {
                        this.validation.new_user.privacy.message =
                            "You need to accept the terms.";
                    }
                    this.validation.new_user.privacy.state = false;
                    is_invalid = true;
                }
            }

            /* */

            Object.keys(this.validation.address).forEach((elem, key) => {
                this.validation.address[elem].message = "";
                this.validation.address[elem].state = null;
            });

            Object.keys(this.validation.billing).forEach((elem, key) => {
                this.validation.billing[elem].message = "";
                this.validation.billing[elem].state = null;
            });

            if (this.should_be_shipped) {
                $.each(this.address, (key, elem) => {
                    if (typeof this.validation.address[key] != "undefined") {
                        if (elem == "") {
                            if (
                                key == "province" &&
                                this.address.country.toLowerCase() != "it"
                            ) {
                                //do nothing
                            } else {
                                if (this.lang == "it") {
                                    this.validation.address[key].message =
                                        "Il campo è obbligatorio";
                                } else {
                                    this.validation.address[key].message =
                                        "This field is required";
                                }

                                this.validation.address[key].state = false;
                                is_invalid = true;
                            }
                        }
                    }
                });
            }

            if (this.user.billing.require_invoice) {
                if (this.billing.type == "company") {
                    $.each(this.billing, (key, elem) => {
                        if (elem == "" && key != "sdi" && key != "pec") {
                            if (this.lang == "it") {
                                this.validation.billing[key].message =
                                    "Il campo è obbligatorio";
                            } else {
                                this.validation.billing[key].message =
                                    "This field is required";
                            }
                            this.validation.billing[key].state = false;
                            is_invalid = true;
                        }
                    });

                    if (this.billing.sdi == "" && this.billing.pec == "") {
                        if (this.lang == "it") {
                            this.validation.billing.pec.message =
                                "Compila PEC o Codice univoco";
                            this.validation.billing.sdi.message =
                                "Compila PEC o Codice univoco";
                        } else {
                            this.validation.billing.pec.message =
                                "Either one between PEC or SDI is required";
                            this.validation.billing.sdi.message =
                                "Either one between PEC or SDI is required";
                        }
                        this.validation.billing.pec.state = false;
                        this.validation.billing.sdi.state = false;

                        is_invalid = true;
                    }
                } else {
                    if (this.billing.fiscal_code == "") {
                        if (this.lang == "it") {
                            this.validation.billing.fiscal_code.message =
                                "Il campo è obbligatorio";
                        } else {
                            this.validation.billing.fiscal_code.message =
                                "This field is required";
                        }
                        this.validation.billing.fiscal_code.state = false;
                        is_invalid = true;
                    } else {
                        if (this.getAge() != null && this.getAge() < 18) {
                            if (this.lang == "it") {
                                this.validation.billing.fiscal_code.message =
                                    "Devi essere maggiorenne per completare l'acquisto";
                            } else {
                                this.validation.billing.fiscal_code.message =
                                    "You must be over 18 years of age to buy our products";
                            }
                            this.validation.billing.fiscal_code.state = false;
                            is_invalid = true;
                        }
                    }
                }
            }

            if (is_invalid) {
                setTimeout(() => {
                    this.btn_disabled = false;

                    let elements = document.querySelectorAll(".invalid");

                    window.scroll({
                        top:
                            parseInt(
                                elements[0].getBoundingClientRect().top +
                                    window.scrollY
                            ) - 250,
                        behavior: "smooth",
                    });
                }, 500);

                return false;
            }

            /* */

            let temp_cart_ids = [];

            Object.keys(this.cart).forEach((key) => {
                temp_cart_ids.push(this.cart[key].name.replace("<br>", " "));
            });

            fbq("track", "AddPaymentInfo", {
                content_category: "checkout",
                content_ids: temp_cart_ids,
                currency: "EUR",
                value: this.finalPrice,
            });

            /* */

            return true;
        },
        getAge() {
            const monthsRepo = {
                A: "01",
                B: "02",
                C: "03",
                D: "04",
                E: "05",
                H: "06",
                L: "07",
                M: "08",
                P: "09",
                R: "10",
                S: "11",
                T: "12",
            };

            return this.billing.fiscal_code.replace(
                /^(?:\w{6})(\d{2})(\w)(\d{2}).+$/,
                function (data, aa, mm, gg) {
                    let year = parseInt(aa, 10);
                    let century = year < 9 ? "20" : "19";
                    year = [century, aa].join("");

                    let day = parseInt(gg, 10);
                    let sex = day > 31 ? "F" : "M";
                    if (sex === "F") day -= 40;

                    let month = mm.toUpperCase();
                    month = monthsRepo[month];

                    let date = [day, month, year].join("/");

                    let result = null;

                    try {
                        result = moment(date, "DD/MM/YYYY")
                            .fromNow(true)
                            .replace(" years", "");
                    } catch (e) {
                        result = null;
                    }

                    return result;
                }
            );
        },
    },
    computed: {
        cart() {
            if (this.cartRaw == null) {
                return null;
            }

            let tmp = {};
            for (const [key, value] of Object.entries(this.cartRaw)) {
                if (
                    typeof value.options.isDiscount == "undefined" ||
                    value.options.isDiscount == false
                ) {
                    tmp[key] = value;
                }
            }

            return tmp;
        },
        managePaymentMethodsCardinal() {
            if (!this.isLogged) {
                return this.user.billing.require_invoice == false
                    ? "03. "
                    : "04. ";
            } else {
                return this.user.billing.require_invoice == false
                    ? "02. "
                    : "03. ";
            }
        },
    },
};
</script>
